define.alias("shared/components/shared/link", "settings/components/shared/link");